import { createSlice } from "@reduxjs/toolkit";

export const chatsSlice = createSlice({
  name: "chats",
  initialState: {
    tokenChat: "",
    chats: [],
    unreadMessages: null,
    hasError: false,
    errorMessage: "",
    isLoading: false,
    unreadConversationSids: [],
    pagination: {
      total: 0,
      page: 1,
      limit: 10,
      totalPages: 1,
    },
  },
  reducers: {
    startLoadingChats: (state) => {
      state.isLoading = true;
    },
    setChats: (state, action) => {
      state.chats = action.payload.chats;
      if (action.payload.pagination) {
        state.pagination = action.payload.pagination;
      }
      state.isLoading = false;
      state.hasError = false;
      state.errorMessage = "";
    },
    setTokenChat: (state, action) => {
      state.tokenChat = action.payload.tokenChat;
      state.hasError = false;
      state.errorMessage = "";
    },
    setUnreadMessages: (state, action) => {
      state.unreadMessages = action.payload.unreadMessages;
      state.hasError = false;
      state.errorMessage = "";
    },
    setErrorChat: (state, action) => {
      state.hasError = true;
      state.errorMessage = action.payload.message;
      state.isLoading = false;
    },
    clearErrorChat: (state) => {
      state.hasError = false;
      state.errorMessage = "";
    },
    markConversationAsUnread: (state, action) => {
      if (!state.unreadConversationSids) {
        state.unreadConversationSids = [];
      }
      if (!state.unreadConversationSids.includes(action.payload)) {
        state.unreadConversationSids.push(action.payload);
      }
    },
    clearUnreadConversation: (state, action) => {
      if (!state.unreadConversationSids) {
        state.unreadConversationSids = [];
      }
      state.unreadConversationSids = state.unreadConversationSids.filter(
        (sid) => sid !== action.payload
      );
    },
    updateChatWithNewMessage: (state, action) => {
      const { conversationSid, body, author, date } = action.payload;
      const chatIndex = state.chats.findIndex(
        (chat) => chat.conversation?.tokenConversation === conversationSid
      );
      
      if (chatIndex !== -1) {
        const chat = state.chats[chatIndex];
        const updatedConversation = {
          ...chat.conversation,
          lastMessage: {
            message: body,
            date: date,
            author: author,
          },
          messagesUnread: (chat.conversation?.messagesUnread || 0) + 1,
        };
        
        state.chats[chatIndex] = {
          ...chat,
          conversation: updatedConversation,
        };
        
        // Re-sort the chats list so that the chat with the newest message moves to the top
        state.chats.sort((a, b) => {
          const dateA = new Date(a.conversation?.lastMessage?.date || "1900-01-01");
          const dateB = new Date(b.conversation?.lastMessage?.date || "1900-01-01");
          return dateB - dateA;
        });
      }
    },
  },
});

export const {
  startLoadingChats,
  setChats,
  setTokenChat,
  setUnreadMessages,
  setErrorChat,
  clearErrorChat,
  markConversationAsUnread,
  clearUnreadConversation,
  updateChatWithNewMessage,
} = chatsSlice.actions;
